<template>
  <div class="container">
      <div class="topDiv" v-if="topType==1">
          <div class="topDiv_item"  @click="showPopup()">
              <span class="topDiv_item_span">{{HT}}</span>
              <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
          </div>
          <div class="topDiv_item_right">
              <div class="searchBg" @click="changetop(2)">
                  <img class="Sreach_icon" src="../../assets/images/search.png" />
                  <span class="Sreach_span">{{searchName?searchName:"搜索商铺名称"}}</span>
              </div>
          </div>
      </div>

      <div class="topDiv" :class="topType==1?'write-phonenum-2000':''" >
          <div class="topDiv_item_right">
              <div class="searchBg1">
                  <img class="Sreach_icon" src="../../assets/images/search.png" />
                  <input
                        ref="search_inp"
                        :class="[str? 'Sreach_inp1' :'Sreach_inp']"
                        type="text"
                        placeholder="搜索商铺名称"
                        v-model="searchName"
                        @keyup="keyup" @keydown="keydown"
                        maxlength="20" @input="inputFun"
                  />
                 <img  v-if="searchName"  @click="cleanStr()"
                    class="Sreach_closeicon"
                    src="../../assets/images/btn_clear.png"
                 />
              </div>
              <span class="Sreach_cancel" @click="changetop(1)">取消</span>
          </div>

      </div>

      <div class="shop_list1" v-if="dataList.length>0">
            <scroll :allLoaded="allLoaded"   :data="dataList" @pulldown="loadData" @loadUp="loadup"  >
                 <section @click="pushToDetail(item)" :class="[$store.state.common.theme!=3?'list_cell':'list_cell_theme_3' ]" v-for="(item,index) in dataList" :key="index"  >
                     <div :class="[ 'list_item',$store.state.common.theme!=3?'':'list_item-border' ]">  
                          <div class="list_item_left">
                               <img class="list_item_left_icon" :src="item.logUrl" />
                          </div>
                          <div class="list_item_right">
                              <span class="list_item_right_span1">{{item.brandName}}</span>
                              <span class="list_item_right_span2">{{item.address}}</span>
                              <div class="list_item_right_div1">
                                  <span class="list_item_right_span3"  v-for="(sitem,sindex) in item.discountList" :key="sindex">{{sitem}}</span>
                              </div>
                               <div class="list_item_right_div1">
                                  <span class="list_item_right_span4"  v-for="(sitem,sindex) in item.tagNameList" :key="sindex">#{{sitem}}</span>
                              </div>
                          </div>
                     </div>
                 </section>
            </scroll>
      </div>
      <div class="nodateview" v-else>
          <span class="nodateviewSpan" v-if="isLoding" >{{nodatemessage}}</span>
           <span class="nodateviewSpan" v-else-if="searchName" >{{"无搜索结果"}}</span>
           <span class="nodateviewSpan" v-else-if='topType==1' >{{"还没商铺数据"}}</span>
      </div>

      <div class="popview" v-if="showPop">
          <div class="popviewBody">
              <div class="popviewItem" v-for="(item,index) in HTList" :key="index"  @click="selectVType(index)" >
                  <span :class="[index==HTListIndex? $store.state.common.theme!=3?'popviewItemSpan1':'popviewItemSpan1_theme_3' :'popviewItemSpan']">{{item.dictName}}</span>
              </div>
          </div>
      </div>

  </div>
</template>

<script>
let timer = "";
import { getShopsByMarketId ,getSystemDistList} from "../../utils/api";
import util from "../../utils/util";
import { mapState } from 'vuex';
import Scroll from "../../components/scroll";
export default {
  name: 'BusinessLife',
  components: {
     Scroll,
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data () {
    return {
      timer1:'',
      pageNo: 1,
      focus:true,
      isLoding:false,
      noMore: false,
      loaded: false,
      typeCode :'',
      searchName:'',

      contractNo:"",
      nodatemessage:'搜索中...',
      dataList: [],
      smallList:[1,2,3], //,4,5,6,7,8,9,10
      HTList:[],
      HTListIndex:0,
      allLoaded:false,
      isLoaded:false,
      topType:1,
      str:'',
      HT:'全部分类',
      showPop:false,
    }
  },

   created() {
        if(this.$route.query.pageTitle){
            console.log('in pageTitle')
            document.title =this.$route.query.pageTitle
            this.$route.meta.title =this.$route.query.pageTitle
        }
        this.getShopsByMarketId();
        this.getSystemDistList();
   },

  methods: {
        keyup(){

        },
        keydown(){

        },
       inputFun(e) {
           console.log("e === "+ e);
            clearTimeout(timer);
            var that = this;
            if(that.searchName){
                timer = setTimeout(function() {
                        that.pageNo=1;
                        that.getShopsByMarketId();
                }, 500);
            }
      },
        //获取商铺分类
        getSystemDistList(){
            let params = {
                groupCode : "shop_info_brand_type",
            }
            getSystemDistList(params).then(res => {
                if (res.res.code === 10000) {
                    var list = res.body.dictList;
                    var allList =[];
                    var allItem ={"dictName":"全部分类","dictValue":''};
                    allList.push(allItem);
                    this.HTList = [...allList, ...list];
                }
            });
        },

        showPopup(){
            this.showPop=true;
        },
        selectVType(index){
            this. HTListIndex=index;
            this. HT=this.HTList[index].dictName;
            this.typeCode=this.HTList[index].dictValue;
            this.showPop=false
            this.pageNo=1;
            this.getShopsByMarketId();
        },
       changetop(type){
           this.showPop=false;

           this.topType=type;
           if(type==1){
               this.closeInp();
               this.dataList=[];
               this.searchName='';
               this.pageNo=1;
               this.getShopsByMarketId();

           }else{
               this.dataList=[];
               //var that =this;
               this.$refs.search_inp.focus();
            //    this.timer1 = setTimeout(function() {
            //        that.$refs.search_inp.focus();
            //     }, 100);
           }
       },
       cleanStr(){
          this.str='';
          this.searchName='';
       },
        closeInp() {
           this.str = "";
           this.searchName='';
           this.$refs.search_inp.blur();
        },
        //上拉
        loadup(){
         console.log("in loadup");
         if(this.isLoding){
           return;
         }
         if(this.allLoaded){
           return;
         }
         this.pageNo=this.pageNo+1;
         this.getShopsByMarketId();
        },

        //下拉刷新
        loadData(){
         console.log("in loadData")
         if(this.isLoding){
           return;
         }
         console.log("in loadData111")
         this.pageNo=1;
         this.allLoaded =false;
         this.getShopsByMarketId();
        },

        getShopsByMarketId(){
            util.showLoading();
            let params = {
                pageNo: this.pageNo,
                // typeCode :this.typeCode,
                // searchName:this.searchName,
                marketId: this.common.marketInfo.id,
                pageSize: 10
            };
            // if(this.typeCode){
            //     params.typeCode =this.typeCode;
            // }
            if(this.searchName){
                params.searchName =this.searchName;
            }else if(this.typeCode){
                params.typeCode =this.typeCode;
            }
            this.isLoding =true;
            getShopsByMarketId(params).then(res => {
                console.log(res);
                this.isLoding =false;
                this.loaded = true;
                util.hideLoading();
                if (res.res.code === 10000) {
                    var list  =res.body.shopsList.rows;
                    if(list){
                        for(var i=0;i<list.length;i++){
                            var item =list[i];
                            if(item.tagNames){
                                var tels=item.tagNames.split(/[\n\s+,，；;]/g);
                                for (var j = 0; j < tels.length; j++) {
                                    if (tels[j] == "") {
                                        // 删除数组中空值
                                        tels.splice(j, 1);
                                        j--;
                                    }
                        }
                        item.tagNameList =tels;
                               // item.tagNameList =item.tagNames.split(",");
                            }
                            if(item.discount){
                                item.discountList =item.discount.split(",");
                            }
                        }
                    }

                    var totalElements=res.body.shopsList.totalElements;
                    if (this.pageNo === 1) {
                        this.dataList=[];
                        if(list){
                            this.dataList = list;
                        }
                    } else {
                        if(list){
                            this.dataList = [...this.dataList, ...list];
                        }
                    }
                    if(totalElements>this.dataList.length){
                         this.allLoaded=false;
                    }else{
                        this.allLoaded =true;
                    }


                    //this.dataList=
                }
            });
        },


        pushToDetail(item){
            // var url ='/BusinessDetail';
            // this.$router.push(url);
            this.$router.push(`/BusinessDetail/${item.id}`);

        },
    }
  };
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  background-color: #EDEDED;
  position: relative;
  .flex(column);
  .shop_list1 {
    flex: 1;
     height: 500px;
  }
}

.topDiv{
    width: 100%;
    height: 88px;
    flex-direction: row;
    background:#EDEDED;
    display: flex;
}
.write-phonenum-2000{
    position: absolute;
    top:-2000px!important;
}

.topDiv_item{
    height: 88px;
    width:228px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    display: flex;
}
.topDiv_item_span{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}

.topDiv_item_icon{
    width: 24px;
    height: 24px;
    margin-left: 16px;
    display: flex;
}
.topDiv_item_right{
    flex-direction: row;
    flex: 1;
    display: flex;
}
.searchBg{
    margin-top: 10px;
    margin-right: 20px;
    margin-bottom: 10px;
    background:rgba(244,244,244,1);
    border-radius:8px;
    flex-direction: row;
    flex: 1;
    display: flex;
    align-items: center;

}
.searchBg1{
    margin-top: 10px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 10px;
    background:rgba(244,244,244,1);
    border-radius:8px;
    flex-direction: row;
    flex: 1;
    display: flex;
    align-items: center;

}
.Sreach_cancel{
    margin-right: 20px;
    margin-left: 20px;
    margin-top: 24px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}

.Sreach_icon{
    width: 44px;
    height: 44px;
    margin-left: 14px;
}
.Sreach_span{
    margin-left: 16px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(201,201,201,1);
    line-height:40px;

}
.Sreach_inp {
  margin-left: 16px;
  width: 472px;
  height: 40px;
  font-size: 28px;
  background: rgba(244,244,244,1);
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  display: flex;
}

.Sreach_inp1 {
  margin-left: 16px;
  width: 472px;
  height: 40px;
  font-size: 28px;
  background: rgba(244,244,244,1);
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  display: flex;
}

.Sreach_closeicon {
  margin-right: 12px;
  width: 44px;
  height: 44px;
  display: flex;
}

//list部分
.list_cell{
    width:100%;
    background:rgba(238,238,238,1);
    flex-direction: column;
    display: flex;
    margin-top: 20px;
}
.list_cell_theme_3{
    width:100%;
    background:#ffffff;
    flex-direction: column;
    display: flex;
    margin-top: 0px;
}

.list_item{
    margin-left: 20px;
    margin-right: 20px;
    flex: 1;
    display: flex;
    flex-direction:row;
    background:rgba(255,255,255,1);
    border-radius:8px;
    padding: 18px;
   
}
.list_item-border{
    border-radius:0px;
    border-bottom: 1px solid rgba(187, 187, 187, 1)
}


.list_item_left{
    width: 162px;
    margin-right: 20px;
    flex-direction: column;
    display: flex;
}
.list_item_left_icon{
     width: 162px;
     height: 162px;
}
.list_item_right{
    flex: 1;
    flex-direction: column;
    display: flex;
}

.list_item_right_span1{
    font-size:30px;
    width: 490px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:42px;
    max-lines: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

}
.list_item_right_span2{
    height:34px;
    width: 490px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:34px;
    max-lines: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.list_item_right_div1{
    margin-top: 14px;
    flex-direction: row;
    max-height:44px;
    overflow:hidden;
}
.list_item_right_span3{
    height:40px;
    border-radius:4px;
    .border(rgba(252,63,86,0.5));
    font-size:24px;
    color:rgba(252,63,86,1);
    line-height:40px;
    box-sizing:border-box;
    padding-left: 8px;
    padding-right: 8px;
    margin-right: 10px;
    margin-left: 1px;
    margin-bottom: 5px;
    display:inline-block;

}
.list_item_right_span4{
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius:4px;
    background:rgba(235,239,245,1);
    font-size:24px;
    font-weight:500;
    color:rgba(60,100,159,1);
    line-height:36px;
    display:inline-block;
    padding-left: 8px;
    padding-right: 8px;
    margin-bottom: 5px;
    margin-right: 10px;

}
//无数据页面
.nodateview{
   width: 100%;
   flex-direction: column;
   justify-content: center;
   margin-top: 60px;
   margin-bottom: 60px;
   display: flex;
}
.nodateviewSpan{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;
    text-align: center;
}

//pop view
.popview{
    position: absolute;
    left: 0;
    top: 88px;
    width: 100%;
    height: 93.4%;
    background:rgba(0,0,0,0.3);
    flex-direction: column;
    display: flex;
    z-index: 999;
}
.popviewBody{
    width: 100%;
    height: 580px;
    background-color: white;
    flex-direction: column;
    overflow-y:scroll;
    -webkit-overflow-scrolling: touch;

}
.popviewItem{
    width: 100%;
    align-items: center;
    display: flex;
    margin-top: 28px;
    margin-bottom: 28px;
}
.popviewItemSpan{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.popviewItemSpan1{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:#1740DA;
    line-height:40px;
}

.popviewItemSpan1_theme_3{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color: #A1805D;
    line-height:40px;
}


</style>